import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo)
    
    if (typeof window !== 'undefined' && window.plausible) {
      window.plausible('Error', {
        props: {
          message: error.message,
          component: errorInfo.componentStack?.split('\n')[0] || 'Unknown'
        }
      })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full px-6 py-8 bg-white shadow-lg rounded-lg">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Cosmic Misalignment Detected
            </h1>
            <p className="text-gray-600 mb-6">
              The universal calculations encountered an unexpected anomaly. Let's realign the cosmic energies.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors"
            >
              Realign Cosmos
            </button>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              className="w-full mt-2 bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors"
            >
              Continue Journey
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary